import { useSite } from "@inrange/building-manager-api-client";
import { Container, Nav } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import Loading from "../Loading";
import SiteFiles from "./SiteFiles";
import SiteArtifacts from "./siteSections/SiteArtifacts";
import SiteNav from "./siteSections/SiteNav";
import SiteReports from "./siteSections/SiteReports";

const SiteFilesReportsTabs = () => {
  const { siteId, tab } = useParams<{ siteId: string; tab: string }>();
  const { fetchSite } = useSite({ siteId, app: "admin" });
  const site = fetchSite.data?.site;

  if (!fetchSite.isLoading && fetchSite.isError) {
    return <div>Error loading the site.</div>;
  }

  if (fetchSite.isLoading || !site) {
    return <Loading label="Loading site data..." />;
  }

  const siteFileCount = site.siteFiles.filter(
    (file) => file.fileType !== "pvDesignImage"
  ).length;

  const activeTab = tab === "reports" ? "reports" : "files";

  document.title =
    activeTab === "reports"
      ? `Site: ${site.name} - Reports`
      : `Site: ${site.name} - Files`;

  return (
    <>
      <SiteNav />
      <div style={{ padding: "12px", fontSize: "26px" }}>
        {fetchSite?.data?.site?.name}
      </div>
      <div style={{ padding: "8px 12px 0" }}>
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link
              as={Link}
              to={`/site/${siteId}/filesreports/files`}
              active={activeTab === "files"}
              replace
            >
              {`Files (${siteFileCount})`}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              as={Link}
              to={`/site/${siteId}/filesreports/reports`}
              active={activeTab === "reports"}
              replace
            >
              Reports
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <div className="tab-content">
          {activeTab === "files" && <SiteFiles />}
          {activeTab === "reports" && (
            <Container fluid style={{ padding: "12px 12px 0 12px" }}>
              {site.locked ? (
                <div className="mt-2">
                  Report generation disabled on locked site.
                </div>
              ) : (
                <SiteReports site={site} />
              )}
              <SiteArtifacts site={site} />
            </Container>
          )}
        </div>
      </div>
    </>
  );
};

export default SiteFilesReportsTabs;
